import { Card } from 'antd';
import { ReactNode } from 'react';

const OrderItem = ({
    label,
    value,
    className = "",
}: {
    label: string;
    value: string | number | undefined;
    className?: string;
}) => {
    return (
        <div
            className={`d-flex flex-column py-1 lh-sm ${className}`}
            style={{ fontWeight: 300 }}
        >
            <div className="text-black-50">{label}</div>
            <div
                className="fs-6 text-truncate text-black w-100"
                style={{
                    wordWrap: 'break-word',
                    whiteSpace: 'normal',
                    overflow: 'hidden',
                }}
            >
                {typeof value === 'string'
                    ? value.slice(0, 80) + (value.length > 80 ? '...' : '')
                    : String(value).slice(0, 80) +
                      (String(value).length > 80 ? '...' : '')}
            </div>
        </div>
    );
};

const OrderItemInline = ({
    label,
    value,
    className,
    ...props
}: {
    label: string;
    value: string | number;
    className?: string;
    [key: string]: any;
}) => {
    return (
        <div className="d-flex py-1 fw-normal">
            <span className="hcrx-order-gray">{label}&nbsp;</span>
            <span className={`fw-bold ${className}`} {...props}>
                {value}
            </span>
        </div>
    );
};

const OrderContainer = ({
    children,
    ...props
}: {
    children: ReactNode;
    [k: string]: any;
}) => {
    return (
        <Card
            {...props}
            style={{ minWidth: '22em', maxWidth: '62em', width: '100%' }}
            headStyle={{
                fontWeight: 'semibold',
                color: '#58595B',
                padding: '0 1em',
            }}
            bodyStyle={{ padding: '.5em 1em' }}
            className="shadow-sm pb-2 rounded"
            bordered={false}
        >
            {children}
        </Card>
    );
};

const OrderTitle = ({
    children,
    ...props
}: {
    children: ReactNode;
    [k: string]: any;
}) => {
    return (
        <div
            className="d-flex justify-content-between align-items-center text-multiline-truncate"
            {...props}
        >
            {children}
        </div>
    );
};

const OrderFooter = ({
    children,
    ...props
}: {
    children: ReactNode;
    [k: string]: any;
}) => {
    return (
        <div className="d-flex flex-column align-items-end mt-2" {...props}>
            {children}
        </div>
    );
};

const OrderNotFound = ({
    children,
    ...props
}: {
    children: ReactNode;
    [k: string]: any;
}) => {
    return (
        <div
            className="d-flex justify-content-center align-items-center fs-5 text-black-50"
            {...props}
        >
            {children}
        </div>
    );
};

export {
    OrderTitle,
    OrderFooter,
    OrderContainer,
    OrderItem,
    OrderItemInline,
    OrderNotFound,
};
